import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import IncidentCategory from "./routes/IncidentCategory";

export default store => ({
  path: "categories",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "behaviour-categories" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [IncidentCategory(store)],
});
